import * as types from './actionTypes';
import api from 'api/';
import { fileApi } from 'api/';

export function getData(id) {
	// body...
	return async(dispatch,getState) =>{
		dispatch({
			type:types.LOADING
		});
		try{
      const citiesGot = await api.getCities();
      const user = await api.getContributorById(id);
      const cuisines = await api.getCuisines();
      const contributors = await api.getAllContributors();
      let homeCity = citiesGot.map(city => {
        return city.name;
      });
      let cuisineNames = cuisines.map(cuisine => {
        return cuisine.name;
      });
      let cities = citiesGot.map(city => {
        let cityMap = {
          value: city.name,
          label: city.name
        }
        return cityMap;
      });
			dispatch({
        type : types.LOADED,
        homeCity,
        cities,
        citiesGot,
        user,
        cuisines,
        cuisineNames,
        contributors
			});
		}
		catch(error){
			console.log(error);
		}
	}
}

export function postFile(file) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    try {
      const fileResp = await fileApi.postMultiple([file]);
      dispatch({
        type: types.LOADED,
        fileResp
      });
    } catch (error) {
      console.log(error);
    }
  }
}

export function postData(id, data) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    const citiesGot = await api.getCities();
    const user = await api.getContributorById(id);
    const cuisines = await api.getCuisines();
    const contributors = await api.getAllContributors();
    let homeCity = citiesGot.map(city => {
      return city.name;
    });
    let cuisineNames = cuisines.map(cuisine => {
      return cuisine.name;
    });
    let cities = citiesGot.map(city => {
      let cityMap = {
        value: city.name,
        label: city.name
      }
      return cityMap;
    });
    try {
      console.log("action:", data);

      await api.putContributor(data);
      dispatch({
        type: types.LOADED,
        homeCity,
        cities,
        citiesGot,
        user,
        cuisines,
        cuisineNames,
        contributors
      });
    } catch (error) {
      console.log(error);
    }
  }
}
